__webpack_require__.p = "/publicity/greenchain/";